var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":_vm.componentId}},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticStyle:{"display":"flex"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }